import _defineProperty from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.object.assign";
import * as tslib_1 from "tslib";
import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { forwardRefAs, Generic } from "../../base";
import { FileCTA } from "./file-cta";
import { FileIcon } from "./file-icon";
import { FileInput } from "./file-input";
import { FileLabel } from "./file-label";
import { FileName } from "./file-name";
export var FILE_DEFAULTS = {
  alignments: ["centered", "right"],
  sizes: ["small", "medium", "large"]
};
export var File = Object.assign(forwardRefAs(function (_a, ref) {
  var _classNames;

  var align = _a.align,
      boxed = _a.boxed,
      className = _a.className,
      color = _a.color,
      fullwidth = _a.fullwidth,
      hasName = _a.hasName,
      size = _a.size,
      rest = tslib_1.__rest(_a, ["align", "boxed", "className", "color", "fullwidth", "hasName", "size"]);

  return React.createElement(Generic, Object.assign({
    className: classNames("file", (_classNames = {
      "has-name": hasName
    }, _defineProperty(_classNames, "is-".concat(align), align), _defineProperty(_classNames, "is-boxed", boxed), _defineProperty(_classNames, "is-".concat(color), color), _defineProperty(_classNames, "is-fullwidth", fullwidth), _defineProperty(_classNames, "is-".concat(size), size), _classNames), className),
    ref: ref
  }, rest));
}, {
  as: "div"
}), {
  CTA: FileCTA,
  Icon: FileIcon,
  Input: FileInput,
  Label: FileLabel,
  Name: FileName
});
File.displayName = "File";
File.propTypes = {
  align: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  boxed: PropTypes.bool,
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fullwidth: PropTypes.bool,
  hasName: PropTypes.bool,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};